import { useMutation } from "@tanstack/react-query";
import {
  createConsentAPI,
  deleteConsentAPI,
  updateConsentAPI,
} from "./consent.api";

const useAddConsentMutation = () => {
  return useMutation({
    mutationFn: createConsentAPI,
  });
};

const useUpdateConsentMutation = () => {
  return useMutation({
    mutationFn: updateConsentAPI,
  });
};

const useDeleteConsentMutation = () => {
  return useMutation({
    mutationFn: deleteConsentAPI,
  });
};

export {
  useAddConsentMutation,
  useUpdateConsentMutation,
  useDeleteConsentMutation,
};
